import { Component, OnInit } from '@angular/core';
import { VentaService } from 'src/app/services/venta.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Remesa } from 'src/app/interfaces/remesa.interface';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  remesaForm = this.fb.group({
    fecha: [moment().format('YYYY-MM-DD HH:mm:ss')],
    monto: ['', [Validators.required, Validators.min(1)]]
  });

  categorias: Observable<any>;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public service: VentaService
  ) { }

  ngOnInit(): void {
    this.obtenerCategorias();
  }

  obtenerCategorias() {
    this.categorias = this.service.obtenerCategorias();
  }

  agregarDigito(numero: string) {
    let cantidad: string = this.remesaForm.controls.monto.value;
    if (!cantidad) {
      cantidad = numero
    } else {
      cantidad = cantidad + numero;
    }
    this.remesaForm.controls.monto.setValue(Number.parseInt(cantidad, 10));
  }

  borrarDigito() {
    let cantidad: string = this.remesaForm.controls.monto.value.toString();
    if (!cantidad) {
      return;
    }

    if (cantidad.length === 1) {
      this.remesaForm.controls.monto.setValue('');
      return;
    }

    const ultIndex = cantidad.length - 1;
    cantidad = cantidad.substring(0, ultIndex);

    this.remesaForm.controls.monto.setValue(cantidad);
  }

  async guardarRemesa() {
    if (this.remesaForm.controls.monto.invalid) {
      this.remesaForm.controls.monto.setValue('');
      return
    }

    const monto = Number.parseInt(this.remesaForm.controls.monto.value);
    const remesa: Remesa = {
      fecha: this.remesaForm.controls.fecha.value,
      monto
    };

    this.service.caja.remesas.push(remesa);
    await this.service.actualizarRemesa();
    this.cerrarModalRemesas();
    this.router.navigateByUrl('/venta');
  }

  modalRemesas() {
    $('#modalRemesas').modal();
  }

  cerrarModalRemesas() {
    this.remesaForm.reset();
    $('#modalRemesas').modal('hide');
  }

  modalCerrarCaja() {
    $('#modalCerrarCaja').modal();
  }

  cerrarModalCerrarCaja() {
    $('#modalCerrarCaja').modal('hide');
  }

  async cerrarCaja() {
    await this.service.cerrarCaja();
    this.cerrarModalCerrarCaja();
    this.router.navigateByUrl('/login');
  }

}
